import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { FrontLogErrorHandler, FrontLogService } from './core/services/front-log.service';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: '+0900' } },
    { provide: ErrorHandler, useClass: FrontLogErrorHandler },
    { provide: APP_INITIALIZER, multi: true, deps: [FrontLogService], useFactory: (log: FrontLogService) => () => log.installGlobalHandlers() },
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    provideToastr(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({ prefix: '/mypage/assets/i18n/', suffix: '.json', failOnError: true }),
      fallbackLang: 'ja',
    }),
  ],
};
